
<component
  v-if="searchResponse"
  :is="productListComponent"
  :search-request-id="searchRequestId"
  :search-response="searchResponse"
  v-bind="$attrs"
/>
